import type { OTCMissingDependencyError } from './useOTCMissingDependencies';

/**
 * Returns current errors whose source was not present in the previous error list.
 * Reason-only changes for an already-missing source are ignored.
 */
export function getNewOTCMissingDependencyErrors(
  previousErrors: OTCMissingDependencyError[],
  currentErrors: OTCMissingDependencyError[]
): OTCMissingDependencyError[] {
  const previousSources = new Set(previousErrors.map(error => error.source));
  return currentErrors.filter(error => !previousSources.has(error.source));
}
